import { useState } from "react"
import * as S from "../AgendamentoTestDrive.styles"
import { CarSilhouette } from "./CarSilhouette"

/** Imagem de placeholder padrão da Etapa 1 (silhueta do design), hospedada no CDN de
    assets — mesmo padrão do empty-state do `CodeBlock`. Se a imagem não carregar (host
    fora do ar, offline no Storybook), cai na silhueta SVG inline (`CarSilhouette`). */
export const DEFAULT_VEHICLE_PLACEHOLDER_URL =
  "https://static.autoforce.com/plugins/images/global/workspace/test-drive/placeholder-testdrive.webp"

export const DefaultVehiclePlaceholder = () => {
  const [failed, setFailed] = useState(false)

  if (failed) return <CarSilhouette />

  return (
    <S.PreviewImage
      src={DEFAULT_VEHICLE_PLACEHOLDER_URL}
      alt=""
      loading="lazy"
      onError={() => setFailed(true)}
    />
  )
}
